import React, { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';

export function useTheme(storageKey) {
  const [theme, setTheme] = useState(() => localStorage.getItem(storageKey) || 'dark');
  useEffect(() => { localStorage.setItem(storageKey, theme); }, [theme, storageKey]);
  const toggle = () => setTheme(t => (t === 'dark' ? 'light' : 'dark'));
  return [theme, toggle];
}

export function ThemeToggle({ theme, onToggle, testId = 'theme-toggle' }) {
  return (
    <button
      onClick={onToggle}
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label="Toggle theme"
      className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:text-[#D4AF37] hover:border-[#D4AF37]/40 transition-colors flex-shrink-0"
      data-testid={testId}
    >
      {theme === 'dark' ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
}
